import React from "react";

import FormView from "../components/Forms/FormView";

import icon from "../images/AVANCE_02.png";

import "../index.css";

const Account = () => {
    return (
        <div className="container-fluid">
            <div className="row form_overflow">
                <div className="col-md-4 icon_avance_container">
                    <img src={icon} alt="Imagem Avance Revalida" id="icon_avance_revalida" />
                </div>

                <div className="col-md-4">
                    <FormView />
                </div>

                <div className="col-md-4"></div>
            </div>
        </div>
    );
};

export default Account;